var map = {
	"./about_us_shape": 43,
	"./about_us_shape.png": 43,
	"./arrow": 44,
	"./arrow.svg": 44,
	"./contact-envelope": 45,
	"./contact-envelope.png": 45,
	"./contact-pin": 46,
	"./contact-pin.png": 46,
	"./home-bar": 47,
	"./home-bar.png": 47,
	"./linkedin": 48,
	"./linkedin.png": 48,
	"./quotes-primary": 49,
	"./quotes-primary.svg": 49,
	"./search": 50,
	"./search-green": 51,
	"./search-green.svg": 51,
	"./search.svg": 50,
	"./view-more-news": 52,
	"./view-more-news.png": 52,
	"./walla-logo": 53,
	"./walla-logo.png": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76;